export default "__VITE_ASSET__ZMnCzhKm__"